import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'ai-reports',
  size: 'full',
  children: {
    catalog: {
      path: 'catalog',
      size: 'full',
      children: {
        slug: {
          path: ':slug',
          size: 'full',
          children: {
            new: {
              path: 'new',
              size: 'full',
            },
          },
        },
      },
    },
    reports: {
      path: 'reports',
      size: 'full',
      children: {
        reportId: {
          path: ':reportId',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
